import { WindowLocation } from "@reach/router";
import { graphql } from "gatsby";
import React from "react";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import { useIntl } from "react-intl";
import GeneralContentLayout from "../layouts/GeneralContentLayout/GeneralContentLayout";
import PageLayout from "../layouts/PageLayout/PageLayout";
import { CommonContext, SanityCampaign } from "../model/common";
import { SanityCaseStudy } from "../model/impact";
import { GlobalMenus } from "../model/menu";
import { SiteArea } from "../utils/analytics";

export const pageQuery = graphql`
  query CaseStudyPage($_id: String!, $navLanguage: String) {
    menus: sanityGlobalConfig(language: { eq: $navLanguage }) {
      ...MenuData
    }
    page: sanityCaseStudy(_id: { eq: $_id }) {
      _id
      _type
      title
      metaDescription
      socialTitle
      socialDescription
      socialImage {
        ...SanityImage
      }
      location {
        ... on SanityCountry {
          name
        }
        ... on SanityRegion {
          name
        }
      }
      related {
        _id
        _type
        title
        location {
          ... on SanityCountry {
            name
          }
          ... on SanityRegion {
            name
          }
        }
        slug {
          current
        }
        image {
          ...SanityImage
        }
      }
      metaDescription
      _rawContent(resolveReferences: { maxDepth: 7 })
    }
  }
`;

const CaseStudyPage = ({
  pageContext,
  data: { menus, page },
  location
}: CaseStudyPageProps) => {
  const { title } = page;
  const intl = useIntl();
  const caseStudies = intl.formatMessage({ id: "case-studies", defaultMessage: "Case studies" });
  return (
    <PageLayout
      siteArea={SiteArea.IMPACT}
      metadata={{
        title,
        page,
        alternates: pageContext.alternates,
        type: "article"
      }}
      menus={menus}
      messages={pageContext.messages}
      location={location}
    >
      <GeneralContentLayout
        article={page}
        related={page.related}
        relatedTitleId="related-stories"
        breadcrumbs={
          <Breadcrumbs
            breadcrumbs={[
              { title: caseStudies, href: "../" },
              { title, href: "./" }
            ]}
          />
        }
      />
    </PageLayout>
  );
};

export default CaseStudyPage;

interface CaseStudyPageProps {
  data: {
    menus: GlobalMenus;
    page: SanityCaseStudy;
    campaigns: { nodes: SanityCampaign[] };
  };
  location: WindowLocation;
  pageContext: CommonContext;
}
